import { cn } from '@/lib/utils';

interface ProgressProps {
  value: number;
  className?: string;
  showLabel?: boolean;
}

function Progress({ value, className, showLabel = true }: ProgressProps) {
  const clamped = Math.min(100, Math.max(0, value));

  return (
    <div
      className={cn(
        'h-5 w-full overflow-hidden rounded-full bg-[var(--inv-surface-muted-2,#f3ece3)]',
        className,
      )}
      role="progressbar"
      aria-valuenow={clamped}
      aria-valuemin={0}
      aria-valuemax={100}>
      <div
        className="flex h-full items-center justify-center rounded-full bg-[var(--inv-accent)] transition-[width] duration-300 ease-out"
        style={{ width: `${clamped}%` }}>
        {showLabel && clamped > 12 ? (
          <span className="text-[0.7rem] font-semibold text-[var(--inv-on-accent)]">
            {clamped}%
          </span>
        ) : null}
      </div>
    </div>
  );
}

export { Progress };
